import { render, staticRenderFns } from "./Welecome.vue?vue&type=template&id=531e45ff&scoped=true&lang=pug"
import script from "./Welecome.vue?vue&type=script&lang=js"
export * from "./Welecome.vue?vue&type=script&lang=js"
import style0 from "./Welecome.vue?vue&type=style&index=0&id=531e45ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e45ff",
  null
  
)

export default component.exports